// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coreg-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.82);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  backdrop-filter: blur(4px);
}

.coreg-modal-content {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  width: 96vw;
  height: 92vh;
  max-width: 1400px;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 1fr 350px;
  overflow: hidden;
}

.coreg-modal-header {
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: #1f2937;
  color: #fff;
}

.coreg-modal-header h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
}

.coreg-close-button {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  font-size: 1.5rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
}

.coreg-close-button:hover {
  background: rgba(255, 255, 255, 0.28);
}

.coreg-viewer-wrap {
  position: relative;
  min-height: 0;
  background: #111;
}

.coreg-viewer {
  width: 100%;
  height: 100%;
}

.coreg-sidebar {
  border-left: 1px solid #e5e7eb;
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #f9fafb;
}

.coreg-section h4 {
  margin: 0 0 8px;
  font-size: 0.95rem;
}

.coreg-section p {
  margin: 0 0 10px;
  font-size: 0.82rem;
  color: #4b5563;
  line-height: 1.4;
}

.coreg-auth-status {
  margin: 0 0 12px;
  padding: 8px 10px;
  border-radius: 4px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  color: #92400e;
  font-size: 0.8rem;
}

.coreg-auth-status--logged-in {
  background: #ecfdf5;
  border-color: #6ee7b7;
  color: #065f46;
}

.coreg-image-hint {
  margin: 0 0 10px;
  font-size: 0.78rem;
  color: #6b7280;
  line-height: 1.35;
}

.coreg-image-picker {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
  text-align: left;
}

.coreg-image-picker-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.coreg-image-picker-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 6px;
  align-items: center;
}

.coreg-image-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 0.82rem;
  color: #111827;
  cursor: pointer;
}

.coreg-image-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.coreg-image-single {
  display: block;
  padding: 6px 8px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 0.82rem;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.coreg-layer-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 6px;
  align-items: center;
  padding: 8px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 8px;
  font-size: 0.85rem;
}

.coreg-layer-tag {
  font-size: 0.75rem;
  color: #6b7280;
}

.coreg-layout-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 12px;
}

.coreg-layout-toggle .coreg-btn.active {
  background: #dbeafe;
  border-color: #2563eb;
  color: #1e40af;
}

.coreg-opacity-control {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 8px;
  align-items: center;
  font-size: 0.82rem;
  color: #374151;
}

.coreg-opacity-control input[type='range'] {
  width: 100%;
  accent-color: #2563eb;
}

.coreg-opacity-value {
  min-width: 2.5rem;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.coreg-nudge-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.coreg-nudge-row {
  display: grid;
  grid-template-columns: 3.5rem 1fr 1fr;
  gap: 6px;
  align-items: center;
}

.coreg-nudge-label {
  font-size: 0.82rem;
  font-weight: 500;
  color: #374151;
}

.coreg-nudge-btn {
  padding: 6px 0;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  color: #374151;
}

.coreg-nudge-btn:hover:not(:disabled) {
  background: #eff6ff;
  border-color: #93c5fd;
}

.coreg-nudge-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.coreg-layer-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.coreg-btn {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  font-size: 0.8rem;
}

.coreg-btn:hover:not(:disabled) {
  background: #f3f4f6;
}

.coreg-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.coreg-btn.active {
  background: #bbf7d0;
  border-color: #22c55e;
}

.coreg-btn.primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.coreg-btn.primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.coreg-btn-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.coreg-status {
  font-size: 0.82rem;
  color: #374151;
  padding: 8px;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.coreg-status strong {
  color: #111827;
}

.coreg-pin {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1.5px solid #fff;
  color: transparent;
  font-size: 0;
  display: block;
  pointer-events: none;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);
  touch-action: none;
}

.coreg-pin--draggable {
  pointer-events: auto;
  cursor: grab;
  width: 12px;
  height: 12px;
}

.coreg-pin--draggable:hover {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9), 0 0 6px rgba(0, 0, 0, 0.45);
}

.coreg-pin--dragging {
  cursor: grabbing;
}

.coreg-pin--move {
  background: #ef4444;
}

.coreg-pin--onto {
  background: #3b82f6;
}

.coreg-loading,
.coreg-error {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.55);
  font-size: 0.95rem;
}

.coreg-error {
  color: #fecaca;
}

.coreg-data-table,
.coreg-matrix {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.78rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
}

.coreg-data-table th,
.coreg-data-table td,
.coreg-matrix td {
  padding: 5px 8px;
  border-bottom: 1px solid #eef2f7;
  text-align: left;
}

.coreg-data-table th {
  background: #f3f4f6;
  font-weight: 600;
  color: #374151;
}

.coreg-data-table tr:last-child td,
.coreg-matrix tr:last-child td {
  border-bottom: none;
}

.coreg-data-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.coreg-matrix-caption {
  margin: 0 0 8px;
  font-size: 0.8rem;
  color: #4b5563;
}

.coreg-matrix td {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  text-align: center;
  width: 33.33%;
}
`, "",{"version":3,"sources":["webpack://./src/components/CoregModal/CoregModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".coreg-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.82);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1100;\n  backdrop-filter: blur(4px);\n}\n\n.coreg-modal-content {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);\n  width: 96vw;\n  height: 92vh;\n  max-width: 1400px;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  grid-template-columns: 1fr 350px;\n  overflow: hidden;\n}\n\n.coreg-modal-header {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #1f2937;\n  color: #fff;\n}\n\n.coreg-modal-header h3 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n}\n\n.coreg-close-button {\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: #fff;\n  font-size: 1.5rem;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.coreg-close-button:hover {\n  background: rgba(255, 255, 255, 0.28);\n}\n\n.coreg-viewer-wrap {\n  position: relative;\n  min-height: 0;\n  background: #111;\n}\n\n.coreg-viewer {\n  width: 100%;\n  height: 100%;\n}\n\n.coreg-sidebar {\n  border-left: 1px solid #e5e7eb;\n  padding: 16px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background: #f9fafb;\n}\n\n.coreg-section h4 {\n  margin: 0 0 8px;\n  font-size: 0.95rem;\n}\n\n.coreg-section p {\n  margin: 0 0 10px;\n  font-size: 0.82rem;\n  color: #4b5563;\n  line-height: 1.4;\n}\n\n.coreg-auth-status {\n  margin: 0 0 12px;\n  padding: 8px 10px;\n  border-radius: 4px;\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  color: #92400e;\n  font-size: 0.8rem;\n}\n\n.coreg-auth-status--logged-in {\n  background: #ecfdf5;\n  border-color: #6ee7b7;\n  color: #065f46;\n}\n\n.coreg-image-hint {\n  margin: 0 0 10px;\n  font-size: 0.78rem;\n  color: #6b7280;\n  line-height: 1.35;\n}\n\n.coreg-image-picker {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.coreg-image-picker-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.coreg-image-picker-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 6px;\n  align-items: center;\n}\n\n.coreg-image-select {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 0.82rem;\n  color: #111827;\n  cursor: pointer;\n}\n\n.coreg-image-select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.coreg-image-single {\n  display: block;\n  padding: 6px 8px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 0.82rem;\n  color: #374151;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.coreg-layer-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 6px;\n  align-items: center;\n  padding: 8px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  margin-bottom: 8px;\n  font-size: 0.85rem;\n}\n\n.coreg-layer-tag {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.coreg-layout-toggle {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.coreg-layout-toggle .coreg-btn.active {\n  background: #dbeafe;\n  border-color: #2563eb;\n  color: #1e40af;\n}\n\n.coreg-opacity-control {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 8px;\n  align-items: center;\n  font-size: 0.82rem;\n  color: #374151;\n}\n\n.coreg-opacity-control input[type='range'] {\n  width: 100%;\n  accent-color: #2563eb;\n}\n\n.coreg-opacity-value {\n  min-width: 2.5rem;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.coreg-nudge-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.coreg-nudge-row {\n  display: grid;\n  grid-template-columns: 3.5rem 1fr 1fr;\n  gap: 6px;\n  align-items: center;\n}\n\n.coreg-nudge-label {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.coreg-nudge-btn {\n  padding: 6px 0;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 1rem;\n  line-height: 1;\n  color: #374151;\n}\n\n.coreg-nudge-btn:hover:not(:disabled) {\n  background: #eff6ff;\n  border-color: #93c5fd;\n}\n\n.coreg-nudge-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.coreg-layer-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.coreg-btn {\n  padding: 6px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.coreg-btn:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n\n.coreg-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.coreg-btn.active {\n  background: #bbf7d0;\n  border-color: #22c55e;\n}\n\n.coreg-btn.primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.coreg-btn.primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.coreg-btn-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.coreg-status {\n  font-size: 0.82rem;\n  color: #374151;\n  padding: 8px;\n  background: #fff;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.coreg-status strong {\n  color: #111827;\n}\n\n.coreg-pin {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 1.5px solid #fff;\n  color: transparent;\n  font-size: 0;\n  display: block;\n  pointer-events: none;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);\n  touch-action: none;\n}\n\n.coreg-pin--draggable {\n  pointer-events: auto;\n  cursor: grab;\n  width: 12px;\n  height: 12px;\n}\n\n.coreg-pin--draggable:hover {\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9), 0 0 6px rgba(0, 0, 0, 0.45);\n}\n\n.coreg-pin--dragging {\n  cursor: grabbing;\n}\n\n.coreg-pin--move {\n  background: #ef4444;\n}\n\n.coreg-pin--onto {\n  background: #3b82f6;\n}\n\n.coreg-loading,\n.coreg-error {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.55);\n  font-size: 0.95rem;\n}\n\n.coreg-error {\n  color: #fecaca;\n}\n\n.coreg-data-table,\n.coreg-matrix {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.78rem;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.coreg-data-table th,\n.coreg-data-table td,\n.coreg-matrix td {\n  padding: 5px 8px;\n  border-bottom: 1px solid #eef2f7;\n  text-align: left;\n}\n\n.coreg-data-table th {\n  background: #f3f4f6;\n  font-weight: 600;\n  color: #374151;\n}\n\n.coreg-data-table tr:last-child td,\n.coreg-matrix tr:last-child td {\n  border-bottom: none;\n}\n\n.coreg-data-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n}\n\n.coreg-matrix-caption {\n  margin: 0 0 8px;\n  font-size: 0.8rem;\n  color: #4b5563;\n}\n\n.coreg-matrix td {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n  text-align: center;\n  width: 33.33%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
